import 'babel-polyfill'

import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Notifications from 'vue-notification'

import App from './app.vue'
import router from './router'
import store from './store'

import 'normalize.css/normalize.css'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'swiper/dist/css/swiper.css'

import vuetify from './plugin/vuetify'

import * as filters from './filters'
Vue.filter('formatTime', filters.formatTime)
Vue.filter('formatDate', filters.formatDate)
Vue.filter('formatCurrency', filters.formatCurrency)

Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper, {
  keyboard: {
    enabled: true,
    onlyInViewport: false
  }
})
Vue.use(Notifications)

Vue.config.errorHandler = (err, vm, info) => {
  // TODO: エラー情報をAPIに送信するなどしたほうが良い
  try {
    console.log(err.stack, vm, info)
  } catch (e) {
    console.error(e)
  }
}

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App)
}).$mount('#app')
